import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './SubPageMenu.scss';
import { injectIntl } from 'react-intl';

const SubPageMenu = ({
  title, buttonList, onClick, defaultMenu, hideMenu, intl,
}) => {
  if (!buttonList) {
    buttonList = [
      { id: 'crm', label: intl.formatMessage({ id: 'crmForm' }) },
      { id: 'fatca', label: intl.formatMessage({ id: 'fatcaForm' }) },
      { id: 'crs', label: intl.formatMessage({ id: 'crsForm' }) },
      { id: 't&c', label: intl.formatMessage({ id: 'tc' }) },
    ];
  }

  const [current, setCurrent] = useState(defaultMenu);
  const refs = buttonList.reduce((acc, value) => {
    acc[value.id] = React.createRef();
    return acc;
  }, {});

  const containterRef = useRef(null);

  useEffect(() => {
    if (refs[current] && refs[current].current) {
      containterRef.current.scrollTo(refs[current].current.offsetLeft + 10, 0);
    }
  }, [current, refs]);

  const onMenuClick = (id) => {
    setCurrent(id);
    onClick(id);
  };

  return (
    <div className="subpage-menu" ref={containterRef}>
      <span>{intl.formatMessage({ id: title })}</span>

      <nav className="subpage-nav">
        {!hideMenu && buttonList && buttonList.map(item => (
          <button
            ref={refs[item.id]}
            type="button"
            name={item.id}
            key={item.id}
            className={`subpage-nav__item ${item.id === current ? 'subpage-nav__item--active' : ''}`}
            onClick={() => onMenuClick(item.id)}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

SubPageMenu.propTypes = {
  /** sub menu title */
  title: PropTypes.string,
  /** button list */
  buttonList: PropTypes.arrayOf(PropTypes.object),
  /** button event */
  onClick: PropTypes.func,
  /** default menu */
  defaultMenu: PropTypes.string,
  /** hide Sub Nav */
  hideMenu: PropTypes.bool,
};

SubPageMenu.defaultProps = {
  title: 'previewForm',
  buttonList: null,
  onClick: () => { },
  defaultMenu: 'crm',
  hideMenu: false,
};

export default injectIntl(SubPageMenu);
